<ng-container>
  <p-card *ngIf="stepService.showStep">
    <p-steps
      [model]="stepService.items"
      [readonly]="true"
      [activeIndex]="stepService.activeIndex"
    ></p-steps>
  </p-card>
</ng-container>
